/* 16-09 (opdracht Thomas): een starterkit gaat als losse producten de winkelwagen in, want elk
   onderdeel moet zijn eigen voorraad afboeken. De klant hoort er één regel te zien: de kit, met
   daaronder zijn eigen keuze. We laten de losse regels staan (Kaching blijft ze beheren), maar
   verbergen ze en zetten er één kaart voor in de plaats.

   Let op: de winkelwagen is van de Kaching-app, dus dit is DOM-werk op andermans markup. Daarom
   een teller die het hertekenen hard afkapt; zie de eerdere vastloper met twee MutationObservers. */
(function () {
  'use strict';

  var EIG = 'Starterkit';
  var LOOK = 'Jouw look';
  var INHOUD = '_Inhoud';
  var FOTO = '_Foto';
  var RIJ = '.kaching-cart-item-container';
  var MAX_TEKENINGEN = 40;

  var bezig = false;
  var timer = 0;
  var tellingen = 0;
  var venster = 0;
  var gestopt = false;

  function geld(cent) {
    return '€' + (cent / 100).toFixed(2).replace('.', ',');
  }

  function kaal(titel) {
    return String(titel || '').replace(/\s*\([^)]*\)\s*$/, '').replace(/\s+-\s+.*$/, '').trim();
  }

  function haalCart() {
    return window.fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function groepeer(cart) {
    if (!cart || !cart.items) return [];
    var groepen = {}, volgorde = [];
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      var label = p[EIG];
      if (!label) return;
      if (!groepen[label]) {
        groepen[label] = { label: label, regels: [], betaald: [], totaal: 0, origineel: 0, look: '', inhoud: '', kitFoto: '', beeld: '', beeldPrijs: -1, aantal: 0 };
        volgorde.push(label);
      }
      var g = groepen[label];
      g.regels.push(it);
      g.totaal += it.final_line_price;
      g.origineel += it.original_line_price;
      if (p[LOOK] && !g.look) g.look = p[LOOK];
      if (p[INHOUD] && !g.inhoud) g.inhoud = p[INHOUD];
      if (p[FOTO] && !g.kitFoto) g.kitFoto = p[FOTO];
      if (it.final_line_price === 0) {
        // 16-09 (correctie Thomas): de gratis artikelen komen echt mee in de winkelwagen,
        // dus die laten we als eigen regel staan. Alleen de betaalde onderdelen worden een kit.
        if (!g.aantal) g.aantal = it.quantity;   // een cadeau zit er precies één per kit in
      } else if (g.betaald.push(it) && it.image && it.final_line_price > g.beeldPrijs) {
        // de duurste regel is de strips zelf, en dat is de foto die de klant herkent
        g.beeld = it.image;
        g.beeldPrijs = it.final_line_price;
      }
    });
    return volgorde.map(function (l) { return groepen[l]; }).filter(function (g) { return g.betaald.length > 1; });
  }

  function maak(tag, klasse, tekst) {
    var n = document.createElement(tag);
    if (klasse) n.className = klasse;
    if (tekst) n.textContent = tekst;
    return n;
  }

  function verwijder(groep, knop) {
    if (knop.disabled) return;
    knop.disabled = true;
    // In een keer leeghalen met /cart/update.js. Regel voor regel via /cart/change.js liet er
    // twee staan: de app herschikt de winkelwagen tussen de verzoeken door.
    var updates = {};
    groep.regels.forEach(function (it) { updates[it.key] = 0; });
    window.fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lt-kit-cart' }); } catch (e) {}
      }
      setTimeout(function () {
        // reageert de app niet op het leeghalen, dan halen we de pagina op zodat de klant
        // nooit naar een regel kijkt die er niet meer is
        if (document.querySelector('[data-lt-kit="' + groep.label.replace(/"/g, '') + '"]')) window.location.reload();
      }, 1200);
    }).catch(function () { knop.disabled = false; });
  }

  function kaart(groep) {
    var kaart = maak('div', 'lt-kitregel');
    kaart.setAttribute('data-lt-kit', groep.label);

    // de foto van de kit zelf; staat die er niet (oudere winkelwagen), dan de duurste regel
    var bron = groep.kitFoto || groep.beeld;
    if (bron) {
      var beeldvak = maak('div', 'lt-kitregel__beeld');
      var img = document.createElement('img');
      img.src = bron;
      img.alt = '';
      img.loading = 'lazy';
      beeldvak.appendChild(img);
      kaart.appendChild(beeldvak);
    }

    var midden = maak('div', 'lt-kitregel__midden');
    var titel = groep.aantal > 1 ? groep.aantal + 'x ' + groep.label : groep.label;
    midden.appendChild(maak('p', 'lt-kitregel__titel', titel));
    if (groep.look) midden.appendChild(maak('p', 'lt-kitregel__keuze', groep.look));
    if (groep.inhoud) midden.appendChild(maak('p', 'lt-kitregel__inhoud', groep.inhoud));
    kaart.appendChild(midden);

    var rechts = maak('div', 'lt-kitregel__rechts');
    if (groep.origineel > groep.totaal) {
      rechts.appendChild(maak('s', 'lt-kitregel__was', geld(groep.origineel)));
    }
    rechts.appendChild(maak('span', 'lt-kitregel__prijs', geld(groep.totaal)));
    var weg = maak('button', 'lt-kitregel__weg');
    weg.type = 'button';
    weg.setAttribute('aria-label', groep.label + ' verwijderen');
    weg.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" focusable="false"><path d="M2.5 4h11M6 4V2.8h4V4M4 4l.6 9.2h6.8L12 4" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    weg.addEventListener('click', function () { verwijder(groep, weg); });
    rechts.appendChild(weg);
    kaart.appendChild(rechts);

    return kaart;
  }

  function opruimen() {
    var oud = document.querySelectorAll('.lt-kitregel');
    for (var i = 0; i < oud.length; i++) oud[i].parentNode.removeChild(oud[i]);
    var verborgen = document.querySelectorAll('[data-lt-verborgen]');
    for (var j = 0; j < verborgen.length; j++) {
      verborgen[j].style.display = '';
      verborgen[j].removeAttribute('data-lt-verborgen');
    }
  }

  function teken() {
    if (gestopt || bezig) return;
    if (!document.querySelector(RIJ)) return;

    var nu = Date.now();
    if (nu - venster > 5000) { venster = nu; tellingen = 0; }
    tellingen += 1;
    if (tellingen > MAX_TEKENINGEN) {
      gestopt = true;
      opruimen();
      return;
    }

    haalCart().then(function (cart) {
      var groepen = groepeer(cart);
      var rijen = [].slice.call(document.querySelectorAll(RIJ));
      bezig = true;
      opruimen();
      groepen.forEach(function (g) {
        var betaaldeSleutels = {}, alleSleutels = {};
        g.betaald.forEach(function (it) { betaaldeSleutels[it.key] = 1; });
        g.regels.forEach(function (it) { alleSleutels[it.key] = 1; });
        var sleutelVan = function (r) {
          var k = r.querySelector('[data-line-key]');
          return k ? k.getAttribute('data-line-key') : '';
        };
        var teVerbergen = rijen.filter(function (r) { return betaaldeSleutels[sleutelVan(r)]; });
        if (teVerbergen.length < 2) return;
        // De kit hoort bovenaan te staan, met zijn gratis artikelen eronder. Daarom haken we aan
        // de eerste regel van de kit in beeld, cadeaus meegerekend, en niet aan de eerste betaalde.
        var anker = rijen.filter(function (r) { return alleSleutels[sleutelVan(r)]; })[0] || teVerbergen[0];
        if (!anker.parentNode) return;
        anker.parentNode.insertBefore(kaart(g), anker);
        teVerbergen.forEach(function (r) { r.style.display = 'none'; r.setAttribute('data-lt-verborgen', '1'); });
      });
      setTimeout(function () { bezig = false; }, 80);
    }).catch(function () { bezig = false; });
  }

  function plan() {
    clearTimeout(timer);
    timer = setTimeout(teken, 160);
  }

  var obs = new MutationObserver(function (muts) {
    if (bezig || gestopt) return;
    for (var i = 0; i < muts.length; i++) {
      var doel = muts[i].target;
      if (doel && doel.closest && doel.closest('.lt-kitregel')) continue;
      plan();
      return;
    }
  });

  function start() {
    obs.observe(document.body, { childList: true, subtree: true });
    plan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
